
import MapCommand from './MapCommand';

export default class MapCommandClearAllMeasure extends MapCommand {

    constructor(options) {
        super(options);
        this._name = 'CLEAR_ALL_MEASURE';
    }

    execute(olMap, params) {
        let measureLayer = olMap.getMeasureLayer();
        if (measureLayer) {
            let source = measureLayer.getSource();
            source.clear();
        }
    }
}
